import { Typography } from '@material-ui/core';
import { Image, Stack, useResponsiveValue } from '@superdispatch/ui';
import { Box, Button } from '@superdispatch/ui-lab';
import emptySearchLoadsImg from '../../assets/empty_saved_loads.png';
import emptySearchLoadsImgDark from '../../assets/empty_saved_loads_dark.png';
import emptySearchLoadsMobileImg from '../../assets/empty_saved_loads_mobile.png';
import emptySearchLoadsMobileImgDark from '../../assets/empty_saved_loads_mobile_dark.png';
import { useLoadboardContext } from '../../data/LoadboardContext';

export function EmptySavedLoads() {
  const { router } = useLoadboardContext();
  const isMobile = useResponsiveValue(true, true, false);

  return (
    <Box padding="large">
      <Stack align="center" space="medium">
        <Typography variant="h3" color="textSecondary">
          No loads have been saved yet.
        </Typography>

        <Box
          paddingTop="large"
          paddingBottom="small"
          backgroundColor="White"
          borderRadius="medium"
          width="256px"
        >
          <Stack align="center" space="small">
            <Image
              src={isMobile ? emptySearchLoadsMobileImg : emptySearchLoadsImg}
              srcDark={
                isMobile
                  ? emptySearchLoadsMobileImgDark
                  : emptySearchLoadsImgDark
              }
              alt=""
              width="160px"
            />

            <Typography color="textSecondary" align="center">
              Click the <b>Save Load</b> <br /> icon next to any load <br />{' '}
              that interests you.
            </Typography>
          </Stack>
        </Box>

        <Typography color="textSecondary" align="center">
          Head back to the Super Loadboard to start <br />
          searching for your next load.
        </Typography>

        <Button
          variant="primary"
          onClick={() => {
            router.openPostingsScreen('available');
          }}
        >
          Search All Available Loads
        </Button>
      </Stack>
    </Box>
  );
}
